import { Dispatch, SetStateAction, useMemo } from "react"
import { Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material"
import { Room, TestResultForm } from "../../types"
import { ToolTip } from "../../../dentalenhancements/components/ToolTip"

type RoomField = {
  rooms: Room[],
  formData: TestResultForm,
  setFormData: Dispatch<SetStateAction<TestResultForm>>,
}

const RoomField = (props: RoomField) => {
  const { rooms, formData, setFormData } = props

  const waterlineRoomsById = useMemo(() => {
    const roomsById = new Map(
      rooms.map(room => ([room.room_id, room]))
    )

    return roomsById
  }, [rooms])  

  const handleChange = (event: SelectChangeEvent<number>) => {
    const nextForm = structuredClone(formData)

    const value = Number(event.target.value)
    const room = waterlineRoomsById.get(value)

    const roomId = room?.room_id ?? null
    const description = room?.description ?? null

    nextForm.room_id = roomId
    nextForm.result_description = description

    setFormData(nextForm)
  }

  const label = 'Select a Room/Chair Combination *'
  const value = formData.room_id ?? ''
  const placeholder = 'Select a Room/Chair'

  return (
    <Box>
      <ToolTip
        helpText='To select a room/chair combination, please add a room/chair under manage room chair section.'
        style={{ display: 'inline-block', marginRight: '12px' }}
      />
      <FormControl fullWidth size="small" sx={{ width: '95%' }}>
        <InputLabel>
          { label }
        </InputLabel>
        <Select<number>
          value={value}
          label={label}
          onChange={(event) => handleChange(event)}
          placeholder={placeholder}
        >
          {
            rooms.map(room => {
              return (
                <MenuItem key={room.room_id} value={room.room_id}>
                  { `${room.name} ${room.description}` }
                </MenuItem>
              )
            })
          }
        </Select>
      </FormControl>
    </Box>
  )
}

export default RoomField
